import { ReactElement, createContext, useContext } from 'react';

import useTasks, { TaskState } from '../hooks/useTasks';

const TaskContext = createContext<TaskState | undefined>(undefined);

interface TaskContextProviderProps {
  children: ReactElement | ReactElement[];
}

const TaskContextProvider = ({ children }: TaskContextProviderProps) => {
  const value = useTasks();

  return <TaskContext.Provider value={value}>{children}</TaskContext.Provider>;
};

const useTaskContext = (): TaskState => {
  const context = useContext(TaskContext);

  if (context === undefined) {
    throw new Error('useTaskContext must be used within a TaskContextProvider');
  }

  return context;
};

export { TaskContextProvider, useTaskContext };
